import React, { ReactElement, useRef, useState } from "react";
import IconEditUserAvatar from "@/assets/common/ic_edit_userAvatar.svg?react";
import { message, Upload } from "antd";
import type { GetProp, UploadProps } from "antd";
import { RcFile } from "antd/es/upload";
import { uploadFile } from "@/services/upload";
import { updateUserAvatar } from "@/services/api_user";
import userInfoStore from "@/store/user.store";
type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

interface IProps {
  children: ReactElement;
}
const UserAvatarUploader: React.FC<IProps> = ({ children }) => {
  const [imageUrl, setImageUrl] = useState<string>();
  const abortControllerRef = useRef<AbortController | null>(null);

  const getBase64 = (img: FileType, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const uploadProps: UploadProps = {
    accept: ".jpg, .jpeg, .png, .gif",
    showUploadList: false,
    className: "w-full h-full",
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif"; 
      if (!isJpgOrPng) {
        message.warning('图片格式出错');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.warning('图片不超过2M');
        return false;
      }
      handleUpload(file);
    },
  };

  const handleUpload = async (file: RcFile) => {
    const oldAvatar = userInfoStore.getState().avatar;
     // 预览图片
     getBase64(file, (url) => {
      setImageUrl(url);
      userInfoStore.getState().updateUserInfo({avatar: url});
    });

    // 上传图片
    // 创建一个新的 AbortController 实例
    try {
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadFile(formData, signal);
      await updateUserAvatar(res.downloadUrl);
    } catch (error) {
      console.log("handleUploadAvatar error", error);
      // 将头像回归之前的
      userInfoStore.getState().updateUserInfo({avatar: oldAvatar});
      setImageUrl('');
      message.error('替换头像失败');
    }
  };

  return (
    <div className="relative w-14 h-14 rounded-full">
      <Upload {...uploadProps}>
        {imageUrl ? (
          <img
            src={imageUrl}
            key={imageUrl}
            alt="avatar"
            className="w-14 h-14 rounded-full"
          />
        ) : (
          children
        )}
      <div className="absolute right-0.5 bottom--0.5 bg-#fff w-5 h-5 flex items-center justify-center rounded-full">
        <IconEditUserAvatar />
      </div>
      </Upload>
    </div>
  );
};

export default UserAvatarUploader;
